import { useState, useEffect } from "react";
import { CSDLogoAbout } from "../../assets/data/Imagedata";
import FightForYourRight from "./FightForYourRight.svg";
import { ImFacebook2, ImInstagram, ImTwitter, ImGithub } from "react-icons/im";
import { FaWhatsapp } from "react-icons/fa";
import { FaRegFileLines } from "react-icons/fa6";
import { GlobalData } from "../../assets/data/GlodalData";
import FooterLogo1 from "../../assets/Icons/logo-digital-india.2ecb091.png";
import FooterLogo2 from "../../assets/Icons/logo-indiagov.776ac0f.png";
import FooterLogo3 from "../../assets/Icons/logo-mygov.ea18418.png";
import FooterLogo4 from "../../assets/Icons/logo-nic.bd517ce.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showLanguageBox, setShowLanguageBox] = useState(true);
  const [minimized, setMinimized] = useState(false);

  // Automatically minimize after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => setMinimized(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main className="bg-blue-900 text-secondary relative">
      {/* ===== MAIN FOOTER SECTION ===== */}
      <section className="max-w-screen-xl mx-auto px-5 sm:px-8 py-8 pb-24"> {/* Added pb-24 for bottom padding */}
        <footer className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* === Left Column === */}
          <div className="space-y-4">
      
            <a href="/">
              <img src={CSDLogoAbout} alt="footer_csd" className="w-40 mt-2" />
            </a>

            <p className="text-xs leading-relaxed mt-3">
              We are a dedicated organization committed to protecting and
              empowering consumers across India. Our mission is to ensure every
              consumer's voice is heard by providing a trusted platform to file
              complaints, seek guidance, and resolve issues transparently.
            </p>

            <div className="flex space-x-4 text-lg mt-3">
              <a href={GlobalData.company.companyfacebook}>
                <ImFacebook2 />
              </a>
              <a href={GlobalData.company.companyinstagram}>
                <ImInstagram />
              </a>
              <a href={GlobalData.company.companytwitter}>
                <ImTwitter />
              </a>
              <a href={GlobalData.company.companygit}>
                <ImGithub />
              </a>
            </div>
          </div>

          {/* === Right Columns === */}
          <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 text-xs">
            <div>
              <p className="font-semibold mb-2">Company</p>
              <nav className="flex flex-col space-y-1">
                <a href="/aboutus">About us</a>
                <a href="/voice-of-consumers">Voice of Consumers</a>
              </nav>
            </div>

            <div>
              <p className="font-semibold mb-2">Services</p>
              <nav className="flex flex-col space-y-1">
                <a href="https://search.google.com/local/writereview?placeid=ChIJM0IEPqRRmg0RyLQAP_5varc">
                  Google Map Review
                </a>
                <a href="/reviews">Client Review</a>
              </nav>
            </div>

            <div>
              <p className="font-semibold mb-2">Helpful Links</p>
              <nav className="flex flex-col space-y-1">
                <a href="/contactus">Contact</a>
                <a href="/frequently-asked-questions">FAQs</a>
                <a href={GlobalData.company.companyWhatsapp}>Live Chat</a>
              </nav>
            </div>

            <div>
              <p className="font-semibold mb-2">Legal</p>
              <nav className="flex flex-col space-y-1">
                <a href="/Legal/privacy-policy">Privacy Policy</a>
                <a href="/Legal/terms-and-conditions">Terms & Conditions</a>
                <a href="/Legal/return-policy">Refund Policy</a>
                <a href="/Legal/disclaimer">Disclaimer</a>
                <a href="/Legal/shipping-and-delivery">Shipping & Delivery</a>
              </nav>
            </div>
          </div>
        </footer>

        {/* Divider */}
        <div className="border-t border-gray-600 my-6" />

        {/* Bottom Logos */}
        <div className="flex justify-center items-center gap-4 flex-wrap">
          {[FooterLogo1, FooterLogo2, FooterLogo3, FooterLogo4].map(
            (logo, i) => (
              <img
                key={i}
                src={logo}
                alt={`footer_logo_${i}`}
                className="h-8 sm:h-10 hover:animate-pulse"
              />
            )
          )}
        </div>

        {/* Footer Description */}
        <p className="text-[11px] text-center mt-4 leading-relaxed max-w-4xl mx-auto">
          ISO 9001:2015 Certified - Registered with NITI Aayog, Govt. of India -
          LEI Certified from Ministry of Corporate Affairs - Registered under
          Sections 12A & 80G of the Income Tax Dep. - Enrolled with the Ministry
          of Social Justice and Empowerment - Registered under the Registration
          Act 2001 by Government of Andhra Pradesh
        </p>

        {/* Divider */}
        <div className="border-t border-gray-600 my-6" />

        {/* Copyright */}
        <div className="text-center text-xs space-y-2">
          <p>
            © 2020-{currentYear}{" "}
            <a href="https://cyberspacedigital.in" target="_blank" rel="noopener noreferrer">
              <span className="font-bold">Cyber Space Digital</span>
            </a> All Rights
            Reserved.
          </p>
          <p>A Development & Designer Community (#CSD)</p>

          <div className="flex justify-center space-x-4 pt-2">
            <a href="/Legal/privacy-policy">Privacy Policy</a>
            <a href="/Legal/terms-and-conditions">Terms</a>
            <a href="/Legal/disclaimer">Disclaimer</a>
            <a href="/site-map">Site Map</a>
          </div>
        </div>
      </section>

      {/* ===== Fixed Floating Buttons ===== */}
      <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-between items-end pointer-events-none"> {/* Changed to pointer-events-none on container */}
        
        {/* Left Side - File Case & WhatsApp */}
        <div className="flex flex-col space-y-3 items-start pointer-events-auto"> {/* Added pointer-events-auto */}
          {/* File Case Button */}
          <div className="flex flex-col items-center">
            <Link
              to="/file-case"
              className="w-12 h-12 flex items-center justify-center bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 hover:scale-105 transition-all duration-300 border-2 border-white"
              title="File a Case"
            >
              <FaRegFileLines size={20} />
            </Link>
            <span className="text-[10px] text-white mt-1 bg-black bg-opacity-50 px-1 rounded">File Case</span>
          </div>

          {/* WhatsApp Button */}
          <div className="flex flex-col items-center">
            <a
              href="https://wa.me/919963633653"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 hover:scale-105 transition-all duration-300 border-2 border-white"
              title="Chat on WhatsApp"
            >
              <FaWhatsapp size={20} />
            </a>
            <span className="text-[10px] text-white mt-1 bg-black bg-opacity-50 px-1 rounded">WhatsApp</span>
          </div>
        </div>

        {/* Right Side - Fight Image & Translate */}
        <div className="flex flex-col items-end space-y-3 pointer-events-auto"> {/* Added pointer-events-auto */}
          {/* Fight for Your Right Image */}
          <div className="flex flex-col items-center">
            <img
              src={FightForYourRight}
              alt="FightForYourRight"
              className="w-16 h-16 object-contain"
            />
           
          </div>

          {/* Google Translate Removed */}
        </div>
      </div>
    </main>
  );
};

export default Footer;